export default class TaskPolygons {
  constructor() {
    this.allPolygon = { type: 'FeatureCollection', features: [] }
    this.altitudesPolygon = { type: 'FeatureCollection', features: [] }
    this.speedsPolygon = { type: 'FeatureCollection', features: [] }
    this.gnssNumOfSatellitesPolygon = { type: 'FeatureCollection', features: [] }
    this.gnssStatusPolygon = { type: 'FeatureCollection', features: [] }
    this.guidanceErrorsPolygon = { type: 'FeatureCollection', features: [] }
    this.guidanceHeadingErrorsPolygon = { type: 'FeatureCollection', features: [] }
    this.slantsPolygon = { type: 'FeatureCollection', features: [] }
    this.colorCodedFillPolygon = { type: 'FeatureCollection', features: [] }
  }
}
